import { Component, signal  } from '@angular/core';
import type { ICellRendererAngularComp } from 'ag-grid-angular';
import type { ICellRendererParams } from 'ag-grid-community';
import {MatIconModule} from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { agGridIconParams } from '@models/ag-grid-icon-params.model';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-icon-renderer',
  imports: [
    CommonModule,
    MatIconModule,
  ],
  templateUrl: './icon-renderer.component.html',
  styleUrl: './icon-renderer.component.css'
})
export class IconRendererComponent implements ICellRendererAngularComp{

    link = signal("");
    icon = signal<string>("");
    showDownload: boolean = true;
    onClickFunction: Function | null = null;


    agInit(params: ICellRendererParams): void {
        this.refresh(params);
    }

    refresh(params: ICellRendererParams): boolean {
      let valueParams: agGridIconParams = (params as unknown) as agGridIconParams;
      if(valueParams.link) {
        this.link.set(valueParams.link)
      }

      this.icon.set(valueParams.icon)
      this.showDownload = valueParams.download? true : false;

      if (valueParams.onClick) {
        this.onClickFunction = valueParams.onClick
      }

        return true;
    }

   triggerOnClick(event : any) {
      event.preventDefault();

      if (this.onClickFunction) {
        this.onClickFunction();
      } else {
        console.error('No Function Supplied')
      }
    }
}
